/* LUMUNO interactions: scroll reveals, logo echo, hero parallax, quick add-to-cart. Loaded with defer. */
(function () {
  'use strict';
  window.__lumReady = true;
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveals ---------- */
  function revealHero() {
    document.querySelectorAll('.lum-hero [data-lum-reveal]:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
  }
  function initReveals(root) {
    var els = (root || document).querySelectorAll('[data-lum-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) {
      if (el.closest('.lum-hero')) return; // the hero is revealed directly (after the intro, if one is playing)
      io.observe(el);
    });
    if (doc.classList.contains('lum-intro-on')) {
      document.addEventListener('lumuno:intro-done', revealHero, { once: true });
      setTimeout(revealHero, 5000); // safety net
    } else {
      requestAnimationFrame(revealHero);
    }
  }

  /* ---------- interactive logo: ripple + mist echoes ---------- */
  var echoBusy = 0;
  function echo(target) {
    var now = Date.now();
    if (now - echoBusy < 700) return;
    echoBusy = now;
    var svg = target.querySelector('svg');
    if (!svg) return;
    target.classList.remove('is-pulsing');
    void target.offsetWidth;
    target.classList.add('is-pulsing');
    setTimeout(function () { target.classList.remove('is-pulsing'); }, 950);
    if (reduce || !Element.prototype.animate) return;

    var r = target.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var base = r.top + r.height * 0.72;

    // soft ring from the base of the drop
    var ring = document.createElement('span');
    ring.className = 'lum-ring';
    var size = r.width * 1.1;
    ring.style.cssText = 'left:' + (cx - size / 2) + 'px;top:' + (base - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;';
    document.body.appendChild(ring);
    ring.animate([
      { transform: 'scale(0.4)', opacity: 0.9 },
      { transform: 'scale(3.2)', opacity: 0 }
    ], { duration: 1100, easing: 'cubic-bezier(.16,1,.3,1)' }).onfinish = function () { ring.remove(); };
    setTimeout(function () { ring.remove(); }, 1600);

    // mist echoes that drift upward and fade
    var copies = window.innerWidth < 750 ? 4 : 6;
    for (var i = 0; i < copies; i++) {
      (function (i) {
        var e = document.createElement('span');
        e.className = 'lum-echo';
        e.style.cssText = 'left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px;';
        e.innerHTML = svg.outerHTML;
        document.body.appendChild(e);
        var side = (i % 2 ? 1 : -1) * (6 + i * 4);
        var lift = -(28 + i * 16);
        var scale = 1.25 + i * 0.22;
        var dur = 1200 + i * 120;
        e.animate([
          { transform: 'translate3d(0,0,0) scale(1)', opacity: 0.7, filter: 'blur(0px)' },
          { transform: 'translate3d(' + side * 0.5 + 'px,' + lift * 0.45 + 'px,0) scale(' + (1 + (scale - 1) * 0.5) + ')', opacity: 0.38, filter: 'blur(1.5px)', offset: 0.45 },
          { transform: 'translate3d(' + side + 'px,' + lift + 'px,0) scale(' + scale + ')', opacity: 0, filter: 'blur(4px)' }
        ], { duration: dur, delay: i * 70, easing: 'cubic-bezier(.22,.9,.3,1)', fill: 'both' }).onfinish = function () { e.remove(); };
        setTimeout(function () { e.remove(); }, dur + i * 70 + 400);
      })(i);
    }
  }
  document.addEventListener('click', function (event) {
    var t = event.target.closest && event.target.closest('[data-lum-emblem]');
    if (t) echo(t);
  });

  /* ---------- hero parallax (very light) ---------- */
  function initParallax() {
    var img = document.querySelector('.lum-hero__img');
    if (!img || reduce) return;
    var ticking = false;
    function update() {
      ticking = false;
      var y = Math.min(window.scrollY, 900);
      img.style.setProperty('--lum-par', (y * 0.08).toFixed(1) + 'px');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }

  /* ---------- quick add-to-cart forms (homepage CTA) ---------- */
  function initQuickAdd() {
    document.querySelectorAll('form[data-lum-atc]').forEach(function (form) {
      if (form.__lum) return;
      form.__lum = true;
      form.addEventListener('submit', function (event) {
        var actions = window.Shopify && window.Shopify.actions;
        if (!actions || !actions.updateCart) return; // native POST to /cart/add as fallback
        event.preventDefault();
        var checked = form.querySelector('input[name="id"]:checked') || form.querySelector('[name="id"]');
        var btn = form.querySelector('button[type="submit"]');
        var err = form.querySelector('.lum-cta__err');
        if (!checked) return;
        if (btn) btn.classList.add('is-loading');
        if (err) err.textContent = '';
        actions.updateCart({ lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + checked.value, quantity: 1 }] }, { event: { context: 'product' } })
          .then(function (res) {
            if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
            var drawer = document.querySelector('theme-drawer#cart-drawer');
            setTimeout(function () {
              if (!drawer || !drawer.isOpen) { try { actions.openCart(); } catch (e) { window.location.href = '/cart'; } }
            }, 350);
          })
          .catch(function (e) {
            if (err) err.textContent = (e && e.message) || 'Something went wrong. Please try again.';
          })
          .finally(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    });
  }

  function init() {
    initReveals();
    initParallax();
    initQuickAdd();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor: re-run when sections reload
  document.addEventListener('shopify:section:load', function (e) { initReveals(e.target); initQuickAdd(); });
})();